import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const DEFAULT_FAQ = [
    {
        q: "How much does it cost to make a claim?",
        a: "Absolutely nothing upfront. We work on a 100% No Win, No Fee basis. Our success fee — capped within FCA limits (typically 18 – 30%) — only applies if we successfully recover compensation. You'll have full, transparent fee disclosure in writing before any claim begins. You can also pursue your complaint for free directly with the firm or the Financial Ombudsman Service.",
    },
    {
        q: "How long does a claim take?",
        a: "Most claims complete in 8 – 16 weeks. Straightforward flight delay or data breach claims can settle within a few weeks; complex medical negligence or pension mis-selling cases may take 6 – 18 months. We give you a realistic timeline upfront, and you can track progress in your client portal.",
    },
    {
        q: "Do I need to provide lots of paperwork?",
        a: "No. The eligibility check takes under 60 seconds. Once your case progresses, we may ask for documents you already have (e.g. finance agreement, tenancy, GP notes) — but we do all the chasing, FOIA requests and legal lifting on your behalf.",
    },
    {
        q: "Is ClaimHub UK regulated?",
        a: "ClaimHub UK operates on an FCA-aware basis — we follow FCA standards for claims management activity, work strictly within FCA fee caps, and our claim work is delivered alongside specialist solicitors regulated by the Solicitors Regulation Authority (SRA). We are also registered with the Information Commissioner&apos;s Office (ICO) for GDPR compliance.",
    },
    {
        q: "What if my claim is unsuccessful?",
        a: "You pay nothing. No fees, no hidden costs. The No Win, No Fee promise means the risk sits entirely with us — we only get paid when you do.",
    },
    {
        q: "Can I claim if I've already made a complaint myself?",
        a: "In most cases, yes. If your original complaint was rejected, ignored, or settled for less than you deserved, we can often re-open the matter, escalate to the Financial Ombudsman Service (FOS) or the courts, and fight for a better outcome.",
    },
    {
        q: "How is my data protected?",
        a: "We use bank-level encryption, store data in UK/EEA-regulated data centres, and follow strict GDPR and ICO guidelines. We never sell your details to third parties. You can request deletion of your data at any time via privacy@claimhubuk.co.uk.",
    },
    {
        q: "What information do I need to start?",
        a: "Just the basics — your name, contact details, postcode, and a few quick facts about your claim. The whole eligibility check takes less than a minute.",
    },
];

export default function FAQAccordion({ items = DEFAULT_FAQ, dark = false }) {
    return (
        <section className={`section-pad ${dark ? "bg-navy-900 text-white" : "bg-slate-50"}`}>
            <div className="container-x">
                <div className="grid lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-4">
                        <span className={dark ? "text-eyebrow-light" : "text-eyebrow"}>Frequently asked</span>
                        <h2 className={`mt-3 text-3xl sm:text-4xl lg:text-5xl font-display font-bold tracking-tight ${dark ? "text-white" : "text-navy-900"}`}>
                            Questions, answered.
                        </h2>
                        <p className={`mt-5 text-base leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>
                            Still unsure? Our team is happy to chat — no pressure, no sales calls. Just clear, plain-English answers about your claim.
                        </p>
                    </div>
                    <div className="lg:col-span-8">
                        <Accordion type="single" collapsible className={`rounded-2xl border ${dark ? "border-white/10 bg-white/[0.03]" : "border-slate-200 bg-white"}`}>
                            {items.map((it, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    className={`px-5 sm:px-7 ${dark ? "border-white/10" : "border-slate-200"} ${i === items.length - 1 ? "border-b-0" : ""}`}
                                >
                                    <AccordionTrigger className={`text-left text-base sm:text-lg font-semibold py-5 ${dark ? "text-white hover:text-emerald-300" : "text-navy-900 hover:text-emerald-700"}`}>
                                        {it.q}
                                    </AccordionTrigger>
                                    <AccordionContent className={`text-sm sm:text-base leading-relaxed pb-5 ${dark ? "text-slate-300" : "text-slate-600"}`}>
                                        {it.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
